import React from "react";
import moment from "moment";

import Table from "../../components/table/tableHistory";

import {useGetCommissions} from "../../graphql/graphql/ref/hooks";
import LoadingWall from "../../components/loadingWall";

const commissionHeader = ["Type", "Commision", "Email", "Date"];

const RefCrediitTable = ({title, desc}) => {
  const {data: commissions, loading} = useGetCommissions();

  const commHistoryData = commissions.map((commission) => {
    return {
      Type:
        commission.type == "new" ? (
          <span className="recurring new">New</span>
        ) : (
          <span className="recurring">Recurring</span>
        ),
      Commision: `${commission.credits} credits`,
      Email: commission.email,
      Date: moment(commission.createdAt).format("lll"),
    };
  });

  if (loading) {
    return <LoadingWall />;
  }
  return (
    <Table
      title={title || "Latest Commission History"}
      desc={desc || "This table shows commission history and updates. NEW tags indicate new sign ups. RECURRING means a person you referred before has recently made a payment (remember, you earn commission forever)."}
      tableHeader={commissionHeader}
      rows={commHistoryData || []}
      titleNoRecord="You have no commission history."
      descNoRecord=""
    />
  );
};

export default RefCrediitTable;
